import { toast } from "@devhop/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import type { UpdateDisputeStatusPayload } from "./client";
import { disputesApi } from "./client";

export const disputesKeys = {
  all: ["disputes"] as const,
  summary: () => ["disputes", "summary"] as const,
  list: (q: Partial<OffsetPageQueryDTO>) => ["disputes", "list", q] as const,
  detail: (id: string) => ["disputes", "detail", id] as const,
};

export function useDisputesSummaryQuery() {
  return useQuery({
    queryKey: disputesKeys.summary(),
    queryFn: () => disputesApi.getSummary(),
  });
}

export function useDisputesQuery(query: Partial<OffsetPageQueryDTO> = {}) {
  const params = {
    limit: query.limit ?? 20,
    offset: query.offset ?? 0,
    sort: query.sort,
    filters: query.filters,
  };
  return useQuery({
    queryKey: disputesKeys.list(params),
    queryFn: () => disputesApi.listDisputes(params),
  });
}

export function useDisputeQuery(id: string) {
  return useQuery({
    queryKey: disputesKeys.detail(id),
    queryFn: () => disputesApi.getDispute(id),
    enabled: !!id,
  });
}

export function useUpdateDisputeStatusMutation(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: UpdateDisputeStatusPayload) =>
      disputesApi.updateDisputeStatus(id, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: disputesKeys.all });
      qc.invalidateQueries({ queryKey: disputesKeys.summary() });
      qc.invalidateQueries({ queryKey: disputesKeys.detail(id) });
      toast.success("ດຳເນີນການສຳເລັດ");
    },
    onError: () => {
      toast.error("ດຳເນີນການລົ້ມເຫຼວ");
    },
  });
}
